import React, { useState } from 'react';
import SectionsDrawerItem from '../../SectionsDrawer/SectionsDrawerItem';
import { IDrawerSection } from '../../../Types/Drawer/ISectionsDrawerItem';
import styles from './AnalyseSectionsDrawer.module.css';
import { ContextMenuItem } from '../../../Types/ContextMenuItem';

type AnalyseSectionsDrawerProps = {
  sections: IDrawerSection[];
  archivedSections: IDrawerSection[];
  basePath: string;
  activeSectionId: string | undefined;
  activeItemId: string | undefined;
  onClickHandler?: (item: any) => void;
  sectionsOnly?: boolean;
  toolbar?: React.ReactNode;
  contextMenuItems?: ContextMenuItem[];
  archivedContextMenuItems?: ContextMenuItem[];
  onCheckBoxChanged?: (item: any, checked: boolean) => void;
};

const AnalyseSectionsDrawer: React.FC<AnalyseSectionsDrawerProps> = ({
  sections,
  archivedSections,
  basePath,
  activeSectionId,
  activeItemId,
  onClickHandler,
  sectionsOnly,
  toolbar,
  contextMenuItems,
  archivedContextMenuItems,
  onCheckBoxChanged
}) => {
  const [showArchived, setShowArchived] = useState(false);
  const hasSearchHighlights = sections.some((section) => !!section.searchRelevance);

  return (
    <div className={styles.drawer}>
      {toolbar && <div className={styles.toolbar}>{toolbar}</div>}

      <div className={styles.scrollBody}>
        <div
          className={`${styles.chatList} ${
            hasSearchHighlights ? styles.chatListSearching : ""
          }`}
        >
          {sections.map(section => (
            <SectionsDrawerItem
              key={section.id}
              section={section}
              activeSection={section.id === activeSectionId}
              criteriaExpanded={section.id === activeSectionId}
              activeItemId={activeItemId}
              basePath={basePath}
              onClickHandler={onClickHandler}
              sectionsOnly={sectionsOnly}
              contextMenuItems={contextMenuItems}
              contextMenuPosition="left"
              onCheckBoxChanged={onCheckBoxChanged}
            />
          ))}
        </div>

        {archivedSections.length > 0 && (
          <div className={styles.archivedSection}>
            <div
              className={`${styles.archivedHeader} ${showArchived ? styles.expanded : ''}`}
              onClick={() => setShowArchived(!showArchived)}
            >
              <span className={styles.archivedTitle}>Archived</span>
              <span className={styles.archivedCount}>({archivedSections.length})</span>
              <span className={styles.archivedToggle}>
                {showArchived ? '▼' : '▶'}
              </span>
            </div>

            {showArchived && (
              <div className={styles.archivedContent}>
                {archivedSections.map(section => (
                  <SectionsDrawerItem
                    key={`archived-${section.id}`}
                    section={section}
                    activeSection={section.id === activeSectionId}
                    criteriaExpanded={section.id === activeSectionId}
                    activeItemId={activeItemId}
                    basePath={basePath}
                    onClickHandler={onClickHandler}
                    sectionsOnly={sectionsOnly}
                    contextMenuItems={archivedContextMenuItems}
                    contextMenuPosition="left"
                    onCheckBoxChanged={onCheckBoxChanged}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalyseSectionsDrawer;
